// extracted by mini-css-extract-plugin
module.exports = {"container":"HomeCircleIcon_container__1Rz3S","iconContainer":"HomeCircleIcon_iconContainer__12foy","paperclip":"HomeCircleIcon_paperclip__2AAVQ"};